import { Box, withCitrusTheme } from '@gousto-internal/citrus-react'
import seeds from './seeds.png'

export const OpenTileMenuWrapper = withCitrusTheme(Box, () => ({
  display: 'flex',
  width: '100%',
  height: '100%',
  minHeight: '280px',
  backgroundImage: `url(${seeds})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.15);',
}))
